import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import CallToAction from '@/components/patterns/CallToAction';
import Contact from '@/components/patterns/Contact';
import Edito from '@/components/patterns/Edito';
import FrequentlyAskedQuestions from '@/components/patterns/FrequentlyAskedQuestions';
import Hero from '@/components/patterns/Hero';
import LinksBox from '@/components/patterns/LinksBox';
import Pricing from '@/components/patterns/Pricing';
import RealEstateListing from '@/components/patterns/RealEstateListing';
import ValueProposition from '@/components/patterns/ValueProposition';
import { TrackingView } from '@/tracking';
export const Layout = ({ ...props }) => {
    return (_jsxs(Box, { children: [_jsx(Hero, { ...props }), _jsx(ValueProposition, {}), _jsx(CallToAction, { ...props }), _jsx(Pricing, {}), _jsx(RealEstateListing, {}), _jsx(Edito, {}), _jsx(FrequentlyAskedQuestions, { ...props }), _jsx(Contact, { ...props }), _jsx(LinksBox, {}), _jsx(TrackingView, {})] }));
};
